import _defineProperty from "/Users/p.balahonov/IdeaProjects/remembergood/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/p.balahonov/IdeaProjects/remembergood/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/p.balahonov/IdeaProjects/remembergood/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { triggerGA } from './counters/googl';
import { triggerRb } from './counters/rb';
import { triggerTns } from './counters/tns';
import { triggerTopmail } from './counters/topmail';
import { getAttrs } from './getAttributes';
import { getNodes, nodeSetToArray } from './getElements';
export var AnalyticCounters = /*#__PURE__*/function () {
  /* Определяем глобальные параметры */
  function AnalyticCounters(params) {
    _classCallCheck(this, AnalyticCounters);

    this.params = {
      api: params.api,
      counters: params.counters || {},
      data: params.data,
      debug: params.debug
    };
    var data = this.params.data;
    this.data = {
      referrer: data && data.referrer || (typeof document !== 'undefined' ? document.URL : undefined),
      url: data && data.url || (typeof document !== 'undefined' ? location.href : undefined),
      userid: data && data.userid || ''
    };
  }
  /**
   * Функция инициализации счетчика в зависимости от глобальных параметров
   *
   */


  _createClass(AnalyticCounters, [{
    key: "counterTrigger",
    value: function counterTrigger(counterTriggerOptions) {
      var name = counterTriggerOptions.name,
          extendOptions = counterTriggerOptions.extendOptions,
          _counterTriggerOption = counterTriggerOptions.group,
          group = _counterTriggerOption === void 0 ? 'common' : _counterTriggerOption;
      var counters = this.params.counters;

      if (typeof window === 'undefined' || typeof name === 'undefined' || typeof counters === 'undefined') {
        return;
      } // По умолчанию берем счетчики из группы common


      if (typeof typeof counters.common !== 'undefined' && typeof name === 'string' && typeof counters.common === 'object' && typeof counters.common[name] !== 'undefined') {
        this.triggerCounters(counters.common[name], extendOptions);
      } // Если группа не common берем из нее


      if (group !== 'common' && typeof name === 'string' && typeof counters[group] !== 'undefined' && typeof counters[group] === 'object' && typeof counters[group][name] !== 'undefined') {
        this.triggerCounters(counters[group][name], extendOptions);
      }
    }
    /**
     * Вызвать все счетчики на странице
     * Второй аргумент возвращает для каждого счетчика объект
     * если в `type` пришел `pageview`, то счетчик был вызван триггером
     * #### Example
     * ```
     * {
     *  googl: {
     *    refferer: 'mypage.com'
     *  },
     *  topmail: {
     *    userid: '213131',
     *    referrer: 'https://example.com'
     *  }
     * }
     * ```
     */

  }, {
    key: "triggerAll",
    value: function triggerAll() {
      var _this = this;

      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-counters';
      var params = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof window === 'undefined') {
        return;
      }

      var elements = document.querySelectorAll(selector);
      var api = this.params.api;
      elements = nodeSetToArray(elements);
      elements.forEach(function (el) {
        getNodes(el).forEach(function (item) {
          var attrs = getAttrs(item);
          var customParams = params && params[attrs.type];
          /**
           * Вызываем сначала api, который указан пользователем
           */

          if (api && api[attrs.type] && typeof api[attrs.type] === 'function') {
            /**
             * прокидывать debug параметры для кастомных триггеров
             */
            api[attrs.type](_objectSpread(_objectSpread({}, attrs), {}, {
              type: 'pageview'
            }), customParams);
            return;
          }

          switch (attrs.type) {
            case 'tns':
              triggerTns(_objectSpread({
                src: attrs.src
              }, customParams), _this.params.debug);
              break;

            case 'googl':
              triggerGA(_objectSpread({
                command: 'send',
                location: _this.data.url,
                referrer: _this.data.referrer,
                type: 'pageview'
              }, customParams), _this.params.debug);
              break;

            case 'rbmail':
              triggerRb(_objectSpread({
                id: attrs.id,
                src: attrs.src,
                type: 'pageview'
              }, customParams), _this.params.debug);
              break;

            case 'topmail':
              triggerTopmail(_objectSpread({
                id: attrs.id,
                referrer: _this.data.referrer,
                type: 'pageView',
                url: _this.data.url
              }, customParams), _this.params.debug);
              break;
          }
        });
      });
    }
    /* Триггерим счетчики по типам */

  }, {
    key: "triggerCounters",
    value: function triggerCounters(options, extendOptions) {
      var api = this.params.api;

      for (var item in options) {
        if (options.hasOwnProperty(item)) {
          var counterOptions = _objectSpread(_objectSpread({}, options[item]), extendOptions);

          if (options[item].customProperty && extendOptions && extendOptions.customProperty) {
            Object.assign(counterOptions, {
              customProperty: _objectSpread(_objectSpread({}, options[item].customProperty), extendOptions && extendOptions.customProperty)
            });
          } // Кастомный счетчик переопределяет основной


          if (api && typeof api[item] === 'function') {
            api[item](counterOptions);
            continue;
          } // Триггерим счетчик в зависимости от типа


          switch (item) {
            case 'rbmail':
              triggerRb(counterOptions, this.params.debug);
              break;

            case 'topmail':
              triggerTopmail(counterOptions, this.params.debug);
              break;

            case 'googl':
              triggerGA(_objectSpread({
                referrer: this.data.referrer
              }, counterOptions), this.params.debug);
              break;

            case 'tns':
              triggerTns(counterOptions, this.params.debug);
              break;
          }
        }
      }
    }
  }]);

  return AnalyticCounters;
}();
export default (function (params) {
  return new AnalyticCounters(params);
});